











































import { Component, Vue } from 'vue-property-decorator';
import { TrackResult } from '@/data';
import Track from '@/components/Track.vue';

@Component({
  components: {
    Track,
  },
})
export default class SongSearch extends Vue {
  private noResultsMsg = 'Loading...';
  private query = '';
  private roomID = '';
  private results: TrackResult[] = [];

  private created(): void {
    if (this.$route.query.query instanceof Array) {
      this.query = this.$route.query.query[0];
    } else {
      this.query = this.$route.query.query;
    }
    this.roomID = this.$route.params.id;

    this.$emit('updateTitle', `Results for "${this.query}"`);
    this.search();
  }

  get noResults(): boolean {
    return this.results.length === 0;
  }

  private addOrCheck(inQueue: boolean): string {
    if (inQueue) {
      return 'check';
    }
    return 'plus';
  }

  private addNext(track: TrackResult, index: number): void {
    if (track.inQueue) {
      return;
    }
    this.addSong(track, index, 'addNext');
  }

  private addLast(track: TrackResult, index: number): void {
    if (track.inQueue) {
      return;
    }
    this.addSong(track, index, 'addLast');
  }

  private addSong(track: TrackResult, index: number, addPosition: string): void {
    const url = `room/${this.roomID}/${addPosition}`;
    const req = {id: track.track.id};
    this.$http.post(url, req).then((response) => {
      const data = response.data;
      if (data.Error) {
        this.$emit('ajaxErr', data);
        return;
      }
      this.results[index].inQueue = true;
    });
  }

  private goBack(): void {
    this.$router.back();
  }

  private search(): void {
    if (!this.query) {
      return;
    }
    const url = `room/${this.roomID}/search`;
    const req = {query: this.query};
    this.$http.get(url, {params: req}).then((response) => {
      const data = response.data;
      if (data.RoomNotFound) {
        this.$router.push({name: 'CreateRoom', params: {id: this.roomID}});
        return;
      }
      if (data.Error) {
        this.$emit('ajaxErr', data);
        return;
      }
      this.results = data;
      if (this.noResults) {
        this.noResultsMsg = 'No results found';
      }
    });
  }
}
